import { Injectable } from '@angular/core';
import { LoaderService } from './loader.service';
import { Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpEvent,
  HttpHandler,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
// import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { AppUtil } from './AppUtil';
// import { AppUtilService } from 'client/app/services/app-util.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  constructor(private inj: Injector, private loaderService: LoaderService, public router: Router) {
  }
  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }

    if (this.requests.length > 0 && (this.requests[0].url.includes("/getCurrentTime") || this.requests[0].url.includes("/getInactiveItems"))) {
    } else {
      this.loaderService.status.next(this.requests.length > 0);
    }

  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // console.log('AppUtil.getAccessToken() ==> ' + this.authService.getAccessToken())
    if (req.url.indexOf(environment.serverUrl) >= 0) {
      req = req.clone({
        setHeaders: {
          // authorization: 'Bearer ' + this.authService.getAccessToken()
          authorization: 'Bearer ' + environment.API_AUTH_KEY
        }
      });
    }

    //console.log(req.url.includes("/getCurrentTime") + " " + req.url.includes("/getInactiveItems"));



    this.requests.push(req);

    if (req.url.includes("/getCurrentTime") || req.url.includes("/getInactiveItems")) {
    } else {
      this.loaderService.display(true);
    }

    // We create a new observable which we return instead of the original
    return Observable.create(observer => {
      // And subscribe to the original observable to ensure the HttpRequest is made
      const subscription = next.handle(req).subscribe(
        event => {
          if (event instanceof HttpResponse) {


            this.removeRequest(req);
            observer.next(event);
          }
        },
        err => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.router.navigate(['/login']);
              // this.authService.deleteUserData()
              AppUtil.getAlert('', 'Session has expired, Please login again...')
            }
          }
          this.removeRequest(req);


          observer.error(err);
        },
        () => {
          this.removeRequest(req);


          // if (req.url.indexOf('getAgentDashboardData') < 0) {
          //   const appUtil = this.inj.get(AppUtilService);
          //   appUtil.refreshWallet()
          // }

          observer.complete();


        }
      );
      // return teardown logic in case of cancelled requests
      return () => {
        this.removeRequest(req);


        subscription.unsubscribe();


      };
    });
  }
}
